/* tslint:disable */
/* eslint-disable */
/**
 * David Master Api
 * db: david-master
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the UserCreateDTO interface.
 */
export function instanceOfUserCreateDTO(value) {
    let isInstance = true;
    return isInstance;
}
export function UserCreateDTOFromJSON(json) {
    return UserCreateDTOFromJSONTyped(json, false);
}
export function UserCreateDTOFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'email': !exists(json, 'email') ? undefined : json['email'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'isAdmin': !exists(json, 'isAdmin') ? undefined : json['isAdmin'],
    };
}
export function UserCreateDTOToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'email': value.email,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'isAdmin': value.isAdmin,
    };
}
